<template lang="pug">
	.publisher-search-bar(v-if="Publisher.SelectedPublisher && Publisher.SelectedPublisher.id" :class="Layout.publishersFilter ? 'filter-exist' : ''")
		.search-input-cont
			.search-icon.fa.fa-search
			input.search-input(ref="input" placeholder="Filter publishers..." v-model="filter" @input="filterPublishers")
			.search-remove-icon.fa.fa-remove(v-on:click="removeFilter")
</template>

<script>
	import Screen from './../../mixins/screen'

	import { Publisher } from './../../services/Publisher'
	import { Creative } from './../../services/Creative'
	import { Layout } from './../../services/Layout'

	export default {
		name: 'PublisherSearchBar',
		mixins: [Screen],
		screen: {
			updateOn: ["Layout Workspace Changed", "Selected Publisher Changed", "Selected Creative Changed", "Creative Fully Loaded", "Publishers Filter Changed"],
			events: {
				"Publishers Filter Changed": function(reason) {

					if (reason === "from-local-storage") this.filter = Layout.publishersFilter;

				}
			}
		},
		components: {},
		data() {

			this.Publisher = Publisher;
			this.Creative = Creative;

			return {
				showed: true,
				filter: Layout.publishersFilter
			};

		},
		methods: {

			collectData() {

			},

			filterPublishers() {

				Layout.setPublishersFilter(this.filter);

			},

			removeFilter() {

				this.filter = '';

				Layout.setPublishersFilter('');

			}

		}
	}
</script>

<style lang="sass">

	.publisher-search-bar
		height: 32px
		text-align: center
		overflow: hidden
		margin-top: 1px

		.search-input-cont
			position: relative
			display: flex
			flex-wrap: wrap
			align-items: stretch
			height: 32px
			background-color: rgba(255, 255, 255, 0.00)
			transition: background-color 0.35s ease-in-out

			.search-icon
				width: 30px
				height: 30px
				display: flex
				align-items: center
				justify-content: center
				color: white

				&::before
					opacity: 0.1
					transition: opacity 0.35s ease-in-out

			.search-input
				border: none
				color: rgba(255, 255, 255, 0.17)
				outline: none
				width: 187px
				height: 30px
				background-color: transparent

			.search-remove-icon
				width: 30px
				height: 30px
				display: flex
				align-items: center
				justify-content: center
				color: white

				&::before
					opacity: 0
					transition: opacity 0.35s ease-in-out

		.search-input-cont:focus-within,
		&.filter-exist
			background-color: rgba(255, 255, 255, 0.10)

			.search-icon

				&::before
					opacity: 1

			.search-input
				color: rgba(255, 255, 255, 0.87)

			.search-remove-icon


		&.filter-exist

			.search-remove-icon

				&::before
					opacity: 1
					cursor: pointer

</style>

